import { createSingleQueryParamHook } from '@confluence/route-manager/entry-points/RouteState.ts';

export type PerformanceInsightsTab = 'loadTimes' | 'contentMetrics';

const useTabQueryParam = createSingleQueryParamHook('tab');

export const usePerformanceInsightsTab = (): PerformanceInsightsTab => {
	const selectedTabFromQueryParam = useTabQueryParam();
	switch (selectedTabFromQueryParam) {
		case 'content-metrics':
			return 'contentMetrics';
		case 'load-times':
		default:
			return 'loadTimes';
	}
};
